// third-party
import { FormattedMessage } from 'react-intl';

// project import
import { useSelector } from 'store';

// assets
import { IconDashboard, IconDeviceAnalytics } from '@tabler/icons';

// constant
const dashboardIcon = {
    dashboard: IconDashboard,
    device: IconDeviceAnalytics
};
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

export const DashboardMenu4 = () => {
    const { menuDashboard4 } = useSelector((state) => state.menu);
    const ChildrenList = menuDashboard4?.children?.map((subList) => ({
        id: subList.id,
        title: <FormattedMessage id={`${subList.title}`} />,
        type: subList.type,
        url: subList.url,
        // @ts-ignore
        icon: dashboardIcon[subList.icon],
        breadcrumbs: subList.breadcrumbs
    }));

    const dashboardList = {
        id: menuDashboard4.id,
        title: <FormattedMessage id={`${menuDashboard4.title}`} />,
        // @ts-ignore
        icon: dashboardIcon[menuDashboard4.icon],
        type: menuDashboard4.type,
        children: ChildrenList
    };

    return dashboardList;
};
